<a (click)="selectVolunteer(volunteer)" class="pxp-cities-card-2 pxp-is-featured">
    <div class="pxp-cities-card-2-image-container">
        <div class="pxp-cities-card-2-image pxp-cover" [ngStyle]="{'background-image': 'url(\'' + getUrl(volunteer.spotlightPicture1Url) + '\')'}"></div>
    </div>
    <div class="pxp-cities-card-2-info">
        <div class="pxp-cities-card-2-name">{{volunteer.spotlightName}}</div>
        <div class="pxp-cities-card-2-jobs">Vrijwilliger bij<br>{{volunteer.organizationName}}</div>
    </div>
</a>